import { Injectable, OnDestroy } from '@angular/core'
import { MsalBroadcastService, MsalService } from '@azure/msal-angular'
import { InteractionStatus } from '@azure/msal-browser'
import { BehaviorSubject, Subject } from 'rxjs'
import { filter, takeUntil } from 'rxjs/operators'
import { UsuarioService } from 'src/app/pages/usuarios/usuarios.service'

@Injectable({
	providedIn: 'root',
})
export class LoginService implements OnDestroy {
	authenticated: boolean = false
	private readonly destroy$ = new Subject<void>()

	private userSubject = new BehaviorSubject<any>(null)
	user$ = this.userSubject.asObservable()

  	private userCosmosSubject = new BehaviorSubject<any>(null)
	userCosmos$ = this.userCosmosSubject.asObservable()

	private authenticatedSubject = new BehaviorSubject<boolean>(false)
	authenticated$ = this.authenticatedSubject.asObservable()

	private errorSubject = new BehaviorSubject<string | null>(null)
	error$ = this.errorSubject.asObservable()

	private emailSubject = new BehaviorSubject<any>(null)
	email$ = this.emailSubject.asObservable()

	constructor(private msalService: MsalService, private msalBroadcastService: MsalBroadcastService, private usuarioService: UsuarioService) {
		this.listenForAuthenticationChanges()
	}

	private listenForAuthenticationChanges() {
		this.msalBroadcastService.inProgress$
			.pipe(
				filter((status: InteractionStatus) => status === InteractionStatus.None),
				takeUntil(this.destroy$)
			)
			.subscribe(() => {
				this.loadUserProfile()
				this.updateAuthenticationState()
			})

		this.loadUserProfile()
		this.updateAuthenticationState()
	}

	private updateAuthenticationState() {
		const isAuthenticated = this.msalService.instance.getAllAccounts().length > 0
		this.authenticatedSubject.next(isAuthenticated)
	}

	private async loadUserProfile() {
		const account = this.msalService.instance.getAllAccounts()[0]
		if (account) {
			this.userSubject.next(account)
			this.errorSubject.next(null)
		}
	}

	getUserEmail() {
		const account = this.msalService.instance.getAllAccounts()[0]
		if (account) {
			this.emailSubject.next(account.username)
			this.errorSubject.next(null)
		}
	}

  getUserCosmos() {
    const account = this.msalService.instance.getAllAccounts()[0]
    if (account) {
      this.usuarioService.getEmailUser(account.username).subscribe((res) => {
        if (res.status >= 400) {
          this.errorSubject.next(res.statusText)
        } else if (res.usuario && Object.keys(res.usuario).length > 0) {
          // Usuário encontrado e tem dados
          this.errorSubject.next(null) // Limpa erros anteriores
          this.userCosmosSubject.next(res.usuario)
        } else {
          // Usuário não encontrado no Cosmos (objeto vazio ou null)
          this.errorSubject.next('Usuário não cadastrado no sistema. Entre em contato com o administrador.')
        }
      })
    } else {
      this.errorSubject.next('Usuário não autenticado.')
    }
  }

	logout() {
		this.msalService.logoutRedirect({
			postLogoutRedirectUri: window.location.origin + '/',
		})
		localStorage.removeItem('token')
	}

	ngOnDestroy(): void {
		this.destroy$.next()
		this.destroy$.complete()
	}
}
